import React, { ReactNode, useState, useEffect, useLayoutEffect } from "react";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";

import { colorAuthBackground } from "../../../Constants/theme";

import authBackground from "../../../Images/authBackground.webp";
import {useMediaQuery} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";

type Props = {
	children: ReactNode
}


const Auth: React.FC<Props> = ({children}: Props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const branding = useSelector((state: RootState) => state?.branding);

    return (
        <>
                <Box
                    height="100%"
                    bgcolor={colorAuthBackground}
                    paddingTop="7vh"
                >
                    <Hidden xsDown>
                        <Box
                            position="fixed"
                            marginLeft="auto"
                            marginRight="auto"
                            left="0"
                            right="0"
                            top="100px"
                            textAlign="center"
                            width="100%"
                            zIndex="0"
                        >
                            {
                                !branding.partnerPreferencesOn &&
                                <img src={authBackground} alt="" width="100%" style={{display: "block"}} />
                            }
                        </Box>
                    </Hidden>
                    <Box
                        marginTop={isMobile? "4vh" : "8vh"}
                    >
                        {children}
                    </Box>
                </Box>
        </>
    );
};

export default Auth;
